import type { PlanDefinition, PlansResponse } from '@opinix-cloud/shared';
import { PLANS_FALLBACK } from './plans-fallback';

/**
 * Fetch the plan catalog from the backend. The /api/plans endpoint may not
 * exist yet (pre-deploy, dev sandboxes, marketing-only previews). On any
 * non-2xx, network failure, or shape mismatch we fall back to the hardcoded
 * catalog so /pricing is never broken.
 */
export async function fetchPlans(): Promise<PlanDefinition[]> {
  try {
    const res = await fetch('/api/plans', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      console.info('[plans] /api/plans not OK, using fallback', res.status);
      return PLANS_FALLBACK;
    }
    const body = (await res.json()) as PlansResponse | PlanDefinition[];
    const plans = Array.isArray(body) ? body : body?.plans;
    if (!Array.isArray(plans) || plans.length === 0) {
      console.info('[plans] /api/plans returned unexpected shape, using fallback');
      return PLANS_FALLBACK;
    }
    return plans;
  } catch (err) {
    console.info('[plans] fetch failed, using fallback', err);
    return PLANS_FALLBACK;
  }
}
